<template>
  <div class="card mb-25 border-0 rounded-0 mb-20">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <h5 class="card-title fw-black mb-0">Statistique Utilisateurs</h5>
        </div>
        <div class="row mb-10">
          <div class="col-12">
            <button
              class="btn btn-primary"
              @click="searchData"
              :disabled="isLoader"
            >
              <i class="flaticon-search"></i>
              <div class="spinner-border" role="status" v-if="isLoader">
                <span class="visually-hidden">Loading...</span>
              </div>
              Chercher
            </button>
          </div>
        </div>
      </div>
      <div
        class="chart"
        :style="[isLoader ? { 'pointer-events': 'none', opacity: '0.08' } : '']"
      >
        <apexchart
          type="radialBar"
          height="325"
          :options="productOrdersRadialBar.chartOptions"
          :series="productOrdersRadialBar.series"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import api from "@/utils/axios";
import { onMounted, ref } from "vue";
import { defineComponent, reactive } from "vue";

// If $themeColors is a global variable, you need to import or define it here.
// For demonstration, let's define it locally:
const themeColors = {
  primary: "#007bff",
};

export default defineComponent({
  setup() {
    const chartInfo = ref({});
    const isLoader = ref(false);
    const productOrdersRadialBar = ref({
      series: [0, 0, 0, 0, 0],
      chartOptions: {
        chart: {
          height: 390,
          type: "radialBar",
          width: "100%",
        },
        plotOptions: {
          radialBar: {
            offsetY: 0,
            startAngle: 0,
            endAngle: 270,
            hollow: {
              margin: 5,
              size: "30%",
              background: "transparent",
              image: undefined,
            },
            dataLabels: {
              name: {
                show: false,
              },
              value: {
                show: false,
              },
            },
          },
        },
        colors: [
          themeColors.primary,
          "#F4D03F",
          "#29A708",
          "#76448A",
          "#B93108",
        ],
        labels: [
          "Admin",
          "Livreur",
          "Responsable de Zone",
          "Superviseur",
          "Suivi",
        ],
        legend: {
          show: true,
          floating: true,
          fontSize: "16px",
          position: "left",
          offsetX: 100,
          offsetY: 15,
          labels: {
            useSeriesColors: true,
          },
          markers: {
            size: 0,
          },
          formatter: function (seriesName: string, opts: any) {
            return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
          },
          itemMargin: {
            vertical: 3,
          },
        },
        responsive: [
          {
            breakpoint: 480,
            options: {
              legend: {
                show: false,
              },
            },
          },
        ],
      },
    });

    const searchData = async () => {
      isLoader.value = true;
      try {
        const res = await api.get("/api/auth/UsersData");

        productOrdersRadialBar.value = {
          ...productOrdersRadialBar.value,
          series: res.data.series ?? productOrdersRadialBar.value.series,
          chartOptions: {
            ...productOrdersRadialBar.value.chartOptions,
            colors:
              res.data.colors ??
              productOrdersRadialBar.value.chartOptions.colors,
            labels:
              res.data.months ??
              productOrdersRadialBar.value.chartOptions.labels, // ✅ use labels instead of xaxis
          },
        };
      } catch (error) {
        console.error("Search failed:", error);
      } finally {
        isLoader.value = false;
      }
    };

    onMounted(() => {
      searchData();
    });
    return {
      chartInfo,
      isLoader,
      searchData,
      productOrdersRadialBar,
    };
  },
});
</script>


